import RichText from "../components/RichText";
import { cn } from "@/utilities/ui";
import React from "react";

import type { ContentBlock as ContentBlockProps } from "@/payload-types";

import { CMSLink } from "../components/CMSLink";

export const ContentBlock: React.FC<ContentBlockProps> = (props) => {
  const { columns } = props;

  const colsSpanClasses = {
    full: "lg:col-span-full",
    half: "lg:col-span-6",
    oneThird: "lg:col-span-4",
    twoThirds: "lg:col-span-8",
  };

  return (
    <div className="pb-8 px-4 md:px-14 lg:px-32">
      <div className="grid grid-cols-4 lg:grid-cols-full gap-y-8 gap-x-16">
        {columns &&
          columns.length > 0 &&
          columns.map((col, index) => {
            const { enableLink, link, richText, size } = col;

            return (
              <div
                className={cn(`col-span-4 ${colsSpanClasses[size!]}`, {
                  "md:col-span-2": size !== "full",
                })}
                key={index}
              >
                {richText && (
                  <RichText
                    data={richText}
                    enableGutter={false}
                    className={`prose [&_p]:text-base [&_p]:lg:text-lg`}
                  />
                )}

                {enableLink && <CMSLink {...link} />}
              </div>
            );
          })}
      </div>
    </div>
  );
};
